import { render, staticRenderFns } from "./SyncroSatModal.vue?vue&type=template&id=1ec0ed24"
import script from "./SyncroSatModal.vue?vue&type=script&lang=js"
export * from "./SyncroSatModal.vue?vue&type=script&lang=js"
import style0 from "./SyncroSatModal.vue?vue&type=style&index=0&id=1ec0ed24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports